import { useEffect, useState } from 'react'

const PROFILE_COMPLETION_SKIP_KEY = 'profile_completion_skipped'

export default function useProfileCompletionCheck(
  primaryPlayer,
  user,
  options = {},
) {
  const [showProfileModal, setShowProfileModal] = useState(false)
  const {
    respectSkip = true,
    requiredFields,
    requireSkillLevel = true,
  } = options

  useEffect(() => {
    if (!primaryPlayer || !user) return

    // Check if user has skipped for this session
    const hasSkipped =
      respectSkip &&
      sessionStorage.getItem(PROFILE_COMPLETION_SKIP_KEY) === 'true'
    if (hasSkipped) {
      setShowProfileModal(false)
      return
    }

    // Default required fields or use custom ones
    const defaultRequiredFields = [
      ...(requireSkillLevel ? [primaryPlayer.skill_level] : []),
      primaryPlayer.gender,
      user.firstname,
      user.lastname,
    ]

    const fieldsToCheck = requiredFields || defaultRequiredFields
    const isIncomplete = fieldsToCheck.some(
      (val) => val === null || val === undefined || val === '',
    )

    setShowProfileModal(isIncomplete)
  }, [primaryPlayer, user, respectSkip, requiredFields, requireSkillLevel])

  const skipForSession = () => {
    sessionStorage.setItem(PROFILE_COMPLETION_SKIP_KEY, 'true')
    setShowProfileModal(false)
  }

  const clearSkip = () => {
    sessionStorage.removeItem(PROFILE_COMPLETION_SKIP_KEY)
  }

  return {
    showProfileModal,
    skipForSession,
    clearSkip,
    // Legacy support for existing usage - make the object truthy/falsy like a boolean
    valueOf: () => showProfileModal,
    toString: () => showProfileModal.toString(),
  }
}
